<div class="delete-role-dialog">
  <h2 class="headline">
    {{
      "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
        (selectedVirtualPos?.is_blocked ? "UNLOCK_TITLE" : "BLOCK_TITLE")
        | translate
    }}
  </h2>
  <p class="description">
    {{
      "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
        (selectedVirtualPos?.is_blocked
          ? "UNLOCK_DESCRIPTION"
          : "BLOCK_DESCRIPTION") | translate
    }}
  </p>
  <h3 class="subtitle"></h3>
  <div class="btn-block">
    <button (click)="toggleBlock()" class="btn btn-accent">
      {{
        "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
          (selectedVirtualPos?.is_blocked ? "UNLOCK" : "BLOCK") | translate
      }}
    </button>
    <button (click)="closeModal()" class="btn btn-light">
      {{ "VIRTUAL_POS_PAGE.MODAL_BLOCK.CANCEL" | translate }}
    </button>
  </div>
</div>
